import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fileUrl } from "@/lib/api";
import { Users, ImageSquare } from "@phosphor-icons/react";

const FALLBACK = "https://images.unsplash.com/photo-1770062421988-7929b4748e29?crop=entropy&cs=srgb&fm=jpg&q=70&w=800";

export default function CreatorCard({ creator, index = 0, className = "" }) {
  const banner = creator.banner_id ? fileUrl(creator.banner_id) : FALLBACK;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: (index % 6) * 0.05, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      <Link
        to={`/u/${creator.username}`}
        data-testid={`creator-card-${creator.username}`}
        className="group relative block overflow-hidden bg-card border border-border hover:border-primary/50 transition-colors h-full"
      >
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={banner}
            alt={creator.display_name}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
          <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
            {(creator.categories || []).slice(0, 2).map((c) => (
              <span key={c} className="px-2 py-0.5 glass border border-white/20 text-[10px] font-accent uppercase tracking-wider text-white">
                {c}
              </span>
            ))}
          </div>
          <div className="absolute bottom-0 inset-x-0 p-4">
            <h3 className="font-display text-2xl leading-none mb-1 text-white">{creator.display_name}</h3>
            <p className="text-xs text-white/60 mb-3">@{creator.username}</p>
            <div className="flex items-center gap-4 text-[11px] text-white/70 font-accent">
              <span className="flex items-center gap-1"><Users size={13} weight="fill" />{creator.stats?.subscribers ?? 0}</span>
              <span className="flex items-center gap-1"><ImageSquare size={13} weight="fill" />{creator.stats?.posts ?? 0}</span>
              {creator.subscription_price > 0 && (
                <span className="ml-auto px-2 py-1 bg-primary text-primary-foreground font-bold">
                  ${creator.subscription_price}/mo
                </span>
              )}
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
